import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';
// import { isPermanentSuspensionDate } from '../helpers/suspensionHelper';

export default class PullFrontSuccessedNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-zt-tj.png`;
  }

  href() {
    let post = this.attrs.notification.subject();
    if (!post) {
      return;
    }
    return app.route.post(post);
  }

  content() {
    const notification = this.attrs.notification;
    const title = notification.content().title;
    // const isFronts = notification.content()[0].isFronts;
    return app.translator.trans( 'dl_discussion_controller.forum.notices.banzhu_pull_success_front',
    {title:title});

  }
}
